import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import useStyles from '../useStyles';
import { iRootState } from '../redux/store';

const PaymentStatus = function PaymentStatus(): React.ReactElement {
  const classes = useStyles();
  const updatedDate = useSelector(
    (state: iRootState) => state.quote.paymentStatusUpdatedDate
  );
  const messageId = 'paidOn';
  const defaultMessage = `Paid on {updatedDate, date, short} {updatedDate,time,long}`;

  return (
    <Grid item>
      <Typography className={classes.statusStyle}>
        <FormattedMessage
          id={messageId}
          defaultMessage={defaultMessage}
          values={{ updatedDate }}
        />
      </Typography>
    </Grid>
  );
};

export default PaymentStatus;
